import { render, staticRenderFns } from "./PurchaseInvoiceForm.vue?vue&type=template&id=9c8ce5a4"
import script from "./PurchaseInvoiceForm.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports